<script>
export default {
    name: "OrderExtendInfo",
    props: ['order'],
    data() {
        return {
            orderData: {}
        }
    },
    methods: {
        valueChange(key) {
            this.$emit('value-change', {key, value: this.orderData[key]});
        },
        initOrderData() {
            this.orderData = this.order;
        }
    },
    created() {
        this.initOrderData();
    },
    watch: {
        order() {
            this.initOrderData();
        }
    },
}
</script>

<style scoped>

</style>
